<template>
    <MiscLink
        :to="getConfig?.link?.value"
        class="h-full flex flex-col"
    >
        <div class="w-full flex-shrink-0 overflow-hidden rounded-lg flex items-center justify-center aspect-square">
            <LayoutImage
                v-if="getMedia"
                :media="getMedia"
                :preload="isFirst"
                :lazy-load="!isFirst"
                class="max-w-none w-auto h-full"
            />
        </div>

        <div class="pt-4 justify-between flex-grow flex flex-col">
            <div
                v-if="getConfig?.text?.value"
                class="prose max-w-none prose-headings:font-semibold"
                :class="textClasses"
                :style="variant === 'variant2' ? { color: '#F9F5E8' } : {}"
                v-html="getConfig?.text?.value"
            />

            <div>
                <div
                    class="flex items-center gap-1 text-xl py-2 mt-1 font-semibold"
                    :class="linkClasses"
                >
                    {{ getConfig?.linkText?.value }}
                    <MiscIcon
                        :name="'chevron-right'"
                        :size="'lg'"
                    />
                </div>
            </div>
        </div>
    </MiscLink>
</template>

<script setup lang="ts">
import type { HblSlot } from '@/utils/types'
import { computed } from "vue";

const props = defineProps<{
    config: HblSlot
    isFirst?: boolean
}>()

const getMedia = computed(() => {
    return props?.config?.media
})

const getConfig = computed(() => {
    // @ts-ignore
    return props?.config?.config
})

const variant = computed(() => {
    return getConfig.value?.variant?.value || 'variant1'
})

const textClasses = computed(() => {
    switch (variant.value) {
    case 'variant2':
        return 'prose-headings:!text-base-200 prose-p:!text-base-200 prose-li:!text-base-200 prose-strong:!text-base-200'
    case 'variant3':
    case 'variant1':
    default:
        return ''
    }
})

const linkClasses = computed(() => {
    switch (variant.value) {
    case 'variant2':
        return '!text-base-200'
    case 'variant3':
        return '!text-sale'
    case 'variant1':
    default:
        return ''
    }
})
</script>